<template>
<v-main class="pa-3 pb-4">
  <v-card class="rounded-xl">
    <v-card-title>
      <v-toolbar-title>Lista de Unidades
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" no-data-text="Nenhuma unidade cadastrada" :items="listaUnidades" :search="search" @click="">
      <template v-slot:items="props">
        <td class="title">{{ props.item.nomeUnidade }}</td>
        <td class="title">{{ props.item.nomeUnidadeEtiqueta }}</td>

        <!-- <td class="justify-center layout px-0">

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn @click="editarNomeUnidadeEtiqueta(props.item)" v-on="on" fab small="">
                <v-icon small color="success">
                  edit
                </v-icon>
              </v-btn>

            </template>
            <span>editar etiqueta da unidade</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-btn @click="editarUnidade(props.item)" v-on="on" fab small="" color="success">
                <v-icon small>
                  add
                </v-icon>
              </v-btn>
            </template>
            <span>cadastrar administrador</span>
          </v-tooltip>

        </td> -->
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
        <v-icon small v-on="on" class="mr-2" @click="editarNomeUnidadeEtiqueta(item)">
          mdi-pencil
        </v-icon>
          </template>
        <span>editar etiqueta da unidade</span>
         </v-tooltip>
     
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="success" class="mr-2" @click="editarUnidade(item)">
              add
            </v-icon>
          </template>
          <span>cadastrar administrador</span>
        </v-tooltip>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Sua busca para "{{ search }}" não encontrou resultados.
        </v-alert>
      </template>
    </v-data-table>
  </v-card>
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorService from '../../../services/administrador.service'
import EventBus from '../../../main'

export default {
  name: 'listaAdministrador',
  data() {
    return {
      search: '',
      items: [{
          nomeUnidade: 'Unidade 1',
          idUnidade: '1'
        },
        {
          nomeUnidade: 'Unidade 2',
          idUnidade: '3'
        },
        {
          nomeUnidade: 'Unidade 3',
          idUnidade: '2'
        },
        {
          nomeUnidade: 'Unidade 4',
          idUnidade: '15'
        },
        {
          nomeUnidade: 'Unidade 5',
          idUnidade: '31'
        },
        {
          nomeUnidade: 'Unidade 6',
          idUnidade: '22'
        }
      ],
      isEditing: true,
      unidadeSelecionada: '',
      listaUnidades: [],

      headers: [{
          text: 'Descricao da Unidade ',
          align: 'center',
          value: 'nomeUnidadeEtiqueta',
          sortable: true
        },
        {
          text: 'Etiqueta',
          align: 'center',
          value: 'nomeUnidade',
          sortable: true
        },
        {
          text: 'Ações',
          value: 'actions',
          sortable: false,
          align: 'center'
        }
      ]

    }
  },
  components: {
    // HelloWorld
  },

  mounted() {
    console.log('em mounted lista unid...')
    this.user = this.$store.getters.usuario
    // console.log(this.user);
    this.retornarUnidades()
  },

  methods: {

    editarUnidade(item) {
      console.log('em editar')
      // this.$eventHub.$emit('logged-in',this.unidadeSelecionada);
      this.$router.push({
        name: 'editarUnidade',
        params: {
          item: item
        }
      })
    },

    editarNomeUnidadeEtiqueta(item) {
      console.log('em etiqueta')
      // this.$eventHub.$emit('logged-in',this.unidadeSelecionada);
      this.$router.push({
        name: 'editarNomeUnidadeEtiqueta',
        params: {
          item: item
        }
      })
    },

    retornarUnidades() {
      console.log('em retornar unidades adm...')
      administradorService.administrador
        .retornarUnidades()
        .then(rsp => {
          console.log('rsp oi:')
          this.listaUnidades = rsp.data
          console.log(this.listaUnidades);

        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    }

  },

  created() {
    console.log('created...')
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}
</style>
